export function isBrowser() {
  return (typeof window !== 'undefined');
}

export function isSSR() {
  return !isBrowser();
}

// https://stackoverflow.com/a/26824304/1446284
export function isInt(val) {
  var expression = /^[0-9]+$/;
  return expression.test(val);
}


// https://stackoverflow.com/a/9716488/1446284
export function isNumeric(val) {
  return !isNaN(parseFloat(val)) && isFinite(val);
}

export function isBool(val) {
  if (val === false) return true;
  if (val === true) return true;
  return false;
}

export function isStr(val) {
  return (typeof val === 'string');
}

export function isArray(val) {
  return Array.isArray(val);
}

// Array and function are objects
export function isObject(val) {
  return (typeof val === 'object' && val !== null);
}

export function isEmptyPropValue(val) {
  if (val === "") return true;
  if (val === null) return true;
  if (val === undefined) return true;
  if (val === NaN) return true;
  if (Object.keys(val).length === 0 && val.constructor === Object) return true;
  if (val.length === 0 && val.constructor === Array) return true;
  return false;
}

// loopObject(object, (k, v) => {
//   console.log(`${k}: ${v}`);
// });
export function loopObject(object, callback) {
  for (var k in object) {
    let v = object[k];
    callback(k, v);
  }
}

export function stringContains(string, subString) {
  return string.indexOf(subString) !== -1;
}

export function arrayIndexExists(index, arrayList) {
  if(arrayList[index] === undefined) return false;
  return true;
}

export function convertBoolStr(value) {
  if (!isStr(value)) return null;
  if (value.toLowerCase() === 'false') return false;
  if (value.toLowerCase() === 'true') return true;
  return null;
}

export function inArray(item, arrayList) {
  return arrayList.includes(item);
}

export function removeItemFromArray(item, arrayList) {
  if (inArray(item, arrayList)) {
    arrayList.splice(item, 1);
  }
}

export function addItemToArray(item, arrayList) {
  if (!inArray(item, arrayList)) {
    arrayList.push(item);
  }
}

// Insert item to array at index
export function insertArrayItem(item, items, index) {
  items.splice(index, 0, item);
  return items;
}


// Will remove duplicates by key
// Before: [{"name": "Singapore", "value": "sg"}, {"name": "Singapore", "value": "sg"}]
// After: [{"name": "Singapore", "value": "sg"}]
export function removeDuplicatesForArrayObjects(keyField, items) {
  const results = [];
  const keys = [];
  items.forEach((item) => {
    const key = item[keyField];
    if (keys.includes(key)) return;

    results.push(item);
    keys.push(key);
  })

  return results;
}

export function findDuplicatesInArray(items) {
  const checkedItems = [];
  const duplicates = [];
  items.forEach((item) => {
    const isDuplicate = checkedItems.includes(item);
    const inDuplicateList = duplicates.includes(item);

    if (isDuplicate && !inDuplicateList) {
      duplicates.push(item);
      return;
    }

    checkedItems.push(item);
  })

  return duplicates;
}

// Check if array is subset of another array.
// Return boolean
export function checkArraySubset(parent, child) {
  return child.every(function(val) {
    return parent.indexOf(val) >= 0;
  })
}

// Invert object. Swap keys and values for an object
export function invert(obj) {
  var ret = {};
  for (var key in obj) {
    ret[obj[key]] = key;
  }
  return ret;
}

// check if object is empty
export function isObjectEmpty(obj) {
  if (Object.keys(obj).length > 0) return false
  return true;
}

export function getRandomInt(max, min) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

export function getCurrentTimestamp() {
  return Math.floor(Date.now() / 1000);
}

// Before: hello world
// After: Hello world
export function capitalizeFirstLetter(value) {
  return value.charAt(0).toUpperCase() + value.slice(1);
}

// Before: hello world, HELLO WORLD
// After: Hello World, Hello World
export function toTitleCase(value) {
  return value.replace(/\w\S*/g, function(txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

export function isMobileScreen() {
  var screenWidth = screen.width;
  var screenHeight = screen.height;
  return screenWidth >= 768 ? false : true;
}

export function isSmallerThanTabletScreen() {
  var screenWidth = screen.width;
  var screenHeight = screen.height;
  return screenWidth >= 993 ? false : true;
}

// check if element is overflowed
export function isOverflowed(element) {
  return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
}

export function removeExcessWhitespace(text) {
  return text.replace(/\s+/g, " ").trim();
}

export function getObjectValue(obj, key, defaultVal) {
  if (key in obj) return obj[key];
  return defaultVal;
}

export function handleGoTo(evt, history, link) {
  evt.preventDefault();
  history.push(link);
}

export function handleNewTabGoTo(evt, link) {
  evt.preventDefault();
  window.open(link, "_blank")
}

// 5000 will return 5K
// 50000 will return 50K
// 5 200 000 will return 5.2M
// See https://stackoverflow.com/a/3177985
export function getConciseNum(value) {
  if (value < 1000) {
    return value; // return the same number
  }

  const thousand = 1000;
  const million = 1000*1000;

  if (value < million) {
    return (value/thousand).toFixed(value % thousand != 0)+'K';
  }

  return (value/million).toFixed(value % million != 0)+'M';
}

// Round up to nearest power of 10.
// 4 would return 10
// 42 would return 50
// 422 would return 500
export function roundUpPow10(num) {
  const exp = parseInt(num).toString().length - 1;
  let pow = Math.pow(10, exp);
  pow = pow >= 10 ? pow : 10; // Must be at least 10
  return Math.ceil(num/pow)*pow;
}

export function setLocalStorage(key, val) {
  if (val === null) {
    localStorage.removeItem(key);
  } else {
    localStorage.setItem(key, JSON.stringify(val));
  }
}

export function getLocalStorage(key) {
  const item = localStorage.getItem(key);
  if (!item) return;

  try {
    return JSON.parse(item);
  } catch(e) {}
  return;
}

export function refreshHome() {
  window.location.href = "/";
}

export function copyToClipboard(value) {
  // See https://stackoverflow.com/a/38672314/1446284
  var textarea = document.createElement('textarea')
  textarea.id = 'clipboard_element'
  textarea.style.height = 0
  document.body.appendChild(textarea)

  textarea.value = value;
  var selector = document.querySelector('#clipboard_element')

  selector.select()
  document.execCommand('copy')
  document.body.removeChild(textarea);
}

// Will return "predicate" from "flow:predicate"
export function lastSlice(value, delimiter=":") {
  return value.split(delimiter).splice(-1)[0];
}

// Scroll to top of element. Useful when you are using scrollable elements
export function scrollElementTop(el) {
  el.scrollTop = el.scrollHeight;

  setTimeout(() => {
    el.scrollTop = 0;
  }, 100);
}

// See https://stackoverflow.com/a/36756650/1446284
export function extractFilenameFromUrl(url) {
  return url.split('/').pop().split('#')[0].split('?')[0];
}

export function preventDefault(evt, callback) {
  evt.preventDefault();
  callback();
}


const requestAnimFrame = (function() {
  if (!isBrowser()) return;
  if (window.requestAnimationFrame) return window.requestAnimationFrame;
  return (callback, element) => window.setTimeout(callback, 1000 / 60);
})();

// See https://gist.github.com/joelambert/1002116
export function requestInterval(fn, delay) {
  if (!isBrowser()) return;
  if(!window.requestAnimationFrame) return window.setInterval(fn, delay);

  let start = new Date().getTime();
  let handle = new Object();

  function loop() {
    var current = new Date().getTime(),
      delta = current - start;

    if(delta >= delay) {
      fn.call();
      start = new Date().getTime();
    }

    handle.value = requestAnimFrame(loop);
  };

  handle.value = requestAnimFrame(loop);
  return handle;
}


// See https://gist.github.com/joelambert/1002116
export function clearRequestInterval(handle) {
  if (!isBrowser()) return;
  if (window.cancelAnimationFrame) window.cancelAnimationFrame(handle.value);
  clearInterval(handle);
}

export function appendVariableText(initialText, variableText) {
  if (initialText) {
    if (initialText.endsWith(" ")) return `${initialText}${variableText}`;
    return `${initialText} ${variableText}`;
  }

  return variableText;
}


export function disableIframeLinks(frameWindow) {
  if (!frameWindow) return;

  frameWindow.onclick = (evt) => {
    let el = evt.target;
    if (el.nodeName == 'A') {
      evt.preventDefault();
      return false;
    }
  };

  // this is required to prevent target="_blank"
  let links = frameWindow.document.querySelectorAll('a');
  links.forEach((linkEl) => {
    linkEl.setAttribute("onclick", "return false;");
    linkEl.removeAttribute("target");
  })
}


export function isQuillEmpty(html) {
  const pattern = /<.*?>/g;
  const text = html.replace(pattern, "").trim();
  if (!text) return true;
  return false
}


export function getCssValueForSelector(selector, propKey) {
  if (!isBrowser()) return;
  const el = document.querySelector(selector);
  if (!el) return;

  style = window.getComputedStyle(el);
  return style.getPropertyValue(propKey);
}

// See https://stackoverflow.com/a/43938919/1446284
export function hasParentWithMatchingSelector (target, selector) {
  return [...document.querySelectorAll(selector)].some(el =>
    el !== target && el.contains(target)
  )
}
